// extracted by mini-css-extract-plugin
export default {"main":"offerContent_main__v4JOK","title":"offerContent_title__jAGvp","content":"offerContent_content__x-ODB"};